import React from 'react'
import style from './button.module.scss';

interface BaseProps {
  buttonSize: 'small' | 'medium' | 'large';
  buttonStyle: 'outline' | 'primary' | 'secondary' | 'inverse' | 'inactive';
  theme: 'dark' | 'light'
  element: 'a' | 'button' | 'input';
}

interface ButtonAsInput extends BaseProps, React.ComponentPropsWithoutRef<"input"> {
}

interface ButtonAsButton extends BaseProps, React.ComponentPropsWithoutRef<"button"> {
}

interface ButtonAsA extends BaseProps, React.ComponentPropsWithoutRef<"a"> {
}

type Props = ButtonAsInput | ButtonAsButton | ButtonAsA;

export const Button = (props: Props) => {
  const { element, buttonSize, buttonStyle, className, ...rest } = props;
  const Element = element;

  return (
    // Let's ignore the typing error, it can't seem to figure out
    // Which type of elements it will print. Should work as expected
    // @ts-ignore
    <Element
      className={[
        style[`${props.buttonStyle}-button`],
        style[`${props.buttonStyle}-button-${props.buttonSize}`],
        style[`${props.buttonStyle}-button-${props.buttonSize}-${props.theme}`],
        className
      ].join(' ')}
      {...rest}
    >
      {props.children}
    </Element>
  )
}
